import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { TServiceResult } from '@shared/helper/t-service-result';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpBaseService } from '../base_services/http_base.service';
import { MediaExtensionEnum } from '@app/pages/reviews/models/review-model';

@Injectable({
  providedIn: 'root'
})

export class FileService extends HttpBaseService {

  userImage_$ = new Subject<string>();
  userImageOBS_$ = this.userImage_$.asObservable();

  userBannerImage_$ = new BehaviorSubject<string>('');
  userBannerImage_OBV = this.userBannerImage_$.asObservable();

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'file');
  }

  // ! Uploads API

  uploadFile(uploadedFile: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    // TODO reduce arguments to one
    const up = {
      type,
      objectId,
      uploadedFile,
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/Upload`, up);
  }


  uploadUserPhotos(files: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: str,
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadUserPhotos`, up);
  }

  uploadPhotosByLibrarian(files: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    const base64Data = files.replace(/^data:image\/[a-z]+;base64,/, "");
    const uploadData = {
      type: type,
      objectId: objectId,
      uploadedFile: base64Data,
    };
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadPhotosByLibrarian`, uploadData);
  }

  uploadPublisherPhoto(files: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: str,
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadPublisherPhoto`, up);
  }

  uploadReviewImage(files: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: str,
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadReviewImage`, up);
  }

  uploadReviewImageV2(files: string, type: string, extension = 'jpg'): Observable<TServiceResult<string[]>> {
    const file = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const body = {
      type: type,
      // objectId: objectId,
      uploadedFile: file,
      extension: extension
    }
    return this.http.post<TServiceResult<string[]>>(`${this.fileUrl}/UploadReviewImageV2`, body);
  }


  // ? video upload stream service
  uploadVideoStream(extension: MediaExtensionEnum, file: File): Observable<HttpEvent<HttpEventType>> {
    const header = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
    return this.http.post<HttpEventType>(`${this.fileUrl}/uploadVideoStream`, file, {
      observe: 'events',
      reportProgress: true,
      params: {
        extension: extension
      },
      headers: header
    });
  }

  uploadQuoteImage(files: string, type: string, objectId: string): Observable<TServiceResult<string[]>> {
    // let str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: files,
    }
    return this.http.post<TServiceResult<string[]>>(`${this.fileUrl}/UploadQuoteImage`, up);
  }

  // ! Delete API

  deleteUserPhotos(type: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeleteUserPhotos/${type}`);
  }

  deletePostStoryReviewImage(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeletePostStoryReviewImage/${objectId}/${type}`);
  }

  deleteQuoteImages(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeleteQuoteImages/${objectId}/${type}`);
  }

  // * NEED To EDIT
  deletePhotosByLibrarian(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeletePhotosByLibrarian/${objectId}/${type}`);
  }

  // * NEED To EDIT
  deletePublisherPhoto(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeletePublisherPhoto/${objectId}/${type}`);
  }

  uploadPostStoryImage(files: string, type: string, objectId: string): Observable<TServiceResult<string>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: str,
      extension: 'jpg'
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadPostStoryImage`, up);
  }

  uploadClubImage(files: string, type: string, clubId: string): Observable<TServiceResult<string>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type,
      objectId: clubId,
      uploadedFile: str
    };
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadClubImage`, up);
  }

  deleteClubImage(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeleteClubImages/${objectId}/${type}`);
  }

  uploadMeetingImage(files: string, type: string, meetingId: string): Observable<TServiceResult<string[]>> {
    const str = files.replace(/^data:image\/[a-z]+;base64,/, "")
    const up = {
      type,
      objectId: meetingId,
      uploadedFile: str
    };
    return this.http.post<TServiceResult<string[]>>(`${this.fileUrl}/UploadMeetingImage`, up);
  }

  deleteMeetingImage(type: string, objectId: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeletMeetingImages/${objectId}/${type}`)
  }

  getVideoReadyState(videoId: string): Observable<TServiceResult<boolean>> {
    return this.http.get<TServiceResult<boolean>>(`${this.fileUrl}/GetVideoReadyState/${videoId}`);
  }



  UploadBookImage(files: string, type: string, objectId: string, extension?: string): Observable<TServiceResult<string>> {
    const base64ImageString = typeof files === 'string' ? files : JSON.stringify(files);
    const str = base64ImageString.replace(/^data:image\/[a-z]+;base64,/, '');
    const up = {
      type: type,
      objectId: objectId,
      uploadedFile: str,
      extention: extension,
    }
    return this.http.post<TServiceResult<string>>(`${this.fileUrl}/UploadBookImage`, up);
  }

  deleteBookImage(objectId: string, type: string): Observable<TServiceResult<string>> {
    return this.http.delete<TServiceResult<string>>(`${this.fileUrl}/DeleteBookImage/${objectId}/${type}`);
  }
}
